import { useMemo } from 'react';
import { Crop, BgRot, GoldButton, fitScene } from './Shared';

/* ------------------------------------------------------------------
   "The Golden Quest is open" — shown once on the first open after launch
   (user.liveIntroSeen false). `onDone` marks it seen and continues to the
   hub. Laid out on the 375px stage; the parent sizes / zooms it.
   ------------------------------------------------------------------ */

/* logo top:152 → gems card bottom 542 on the 812px design; may rise to 60
   and must clear the bottom-anchored CTA */
const SCENE = { designTop: 152, height: 390, minTop: 60, bottom: 98 };

export default function GoLive({ registered, unopened = 0, endDay = '11 November', zoom = 1, stageHeight = 812, onDone }) {
  const fit = useMemo(() => fitScene(stageHeight, SCENE), [stageHeight]);
  const copy = registered && unopened > 0
    ? `Every streak is live from now until ${endDay}. Your pre-registration Gems are ready to open.`
    : `Every streak is live from now until ${endDay}. Fill one to earn a Gold Chest for the grand draw.`;

  return (
    <div className="gq-overlay">
      <div className="gq-golive" style={{ zoom, height: stageHeight }} role="dialog" aria-modal="true" aria-label="The Golden Quest is open">
        <BgRot />
        <div className="gq-scene" style={fit.style}>
          <Crop kind="logo" className="gq-logo" alt="The Golden Quest" />
          <div className="gq-copy">
            <div className="gq-h">The Golden Quest is open</div>
            <div className="gq-p">{copy}</div>
          </div>
          <div className="gq-gems">
            <Crop kind="gem" />
            <div>
              <b>1 Gem for every ₹500</b>
              <span>Card, vouchers, gold or referrals</span>
            </div>
          </div>
        </div>
        <GoldButton onClick={onDone}>Start my streaks</GoldButton>
      </div>
    </div>
  );
}
